/**
* @name: xm-img-upload
* @author: weiyong
* @date: 2023-03-03 10:55
* @description：xm-img-upload
* @update: 2023-03-03 10:55
*/
<template>
  <div class="xm-img-upload flex-div" :class="multiple?'multiple':'notMultiple'">
    <xm-img-select v-if="selSystemImg&&disabled!==true"  @setSelImg="setSelImg" v-model:value="businessId"/>
    <empty-img v-if="disabled&&!hasFile"/>
    <a-upload 
      v-model:file-list="fileList"
      :headers="headers"
      accept=".ico,.jpg, .jpeg, .png,.gif"
      name="file"
      :disabled="disabled"
      :data="dataUpload"
      :beforeUpload="beforeUpload"
      list-type="picture-card"
      class="avatar-uploader"
      @preview="handlePreview"
      @remove="removeFile"
      ref="xm-img-upload"
      :show-upload-list="true"
      :action="uploadAction"
      @change="handleChange"
      >
      <div v-if="!disabled">
        <loading-outlined v-if="loadingFlag"></loading-outlined>
        <plus-outlined v-else></plus-outlined>
        <div class="ant-upload-text">{{t(btnLabel)}}</div>
      </div>
    </a-upload>

    <a-image
      :style="{ display: 'none' }"
      :preview="{ visible, onVisibleChange: setVisible }"
      :src="previewImage"
    />
  </div>
</template>

<script lang="ts" setup>
import XmImgSelect from '../fileCtl/xm-img-select.vue';
import {ref, unref, watch} from "vue";
import {useI18n} from "vue-i18n";
import {message, UploadChangeParam,Upload as AUpload, Image as AImage} from "ant-design-vue";
import {PlusOutlined,LoadingOutlined} from "@ant-design/icons-vue";
import {GoingNewUtils} from 'xmgoing-utils'
import {useFileUploadHooks} from "@/components/xmFileComCtl/hooks/useFileUploadHooks";
import {useFileOperation} from "@/components/xmFileComCtl/hooks/useFileOperation";
import {delFileByBusId} from "@/components/fileCtl/api/file";
import type { UploadProps } from 'ant-design-vue';
import GoingUtils from "@/utils/goingUtils";
import EmptyImg from "@/components/xmFileComCtl/coms/emptyImg.vue";

const {t} = useI18n();

interface propTypes {
  maxSize:string,
  imgUrl:string,
  userUploadAction:string,
  listType: string,
  businessId: string,
  selImgFlag:boolean,
  executeFlag:boolean,
  value:string,
  selSystemImg:boolean,
  btnLabel:string,
  multiple: boolean,
  busId:any,
  disabled:boolean,
}
const props = withDefaults(defineProps<propTypes>(), {
  maxSize:'',
  imgUrl:'',
  userUploadAction:'',
  btnLabel:'上传图片',
  //是否可以多文件上传
  multiple: true,
  busId:'',
  businessId: GoingNewUtils.getUUChar(20),
  selSystemImg:true,
  value:'',
  disabled:false,
  selImgFlag:false,
  executeFlag:true,
  listType: 'picture',
})
const {businessId,maxSize,userUploadAction,multiple,imgUrl,busId} = toRefs(props);


const emits = defineEmits([
  'doneFile',
  'update:value','update:busId','update:imgUrl', 'beforeUpload',
  'change', 'done', 'error',
]);
const ctx = {emit: emits}

const setSelImg=function ({activeKey}) {
  ctx.emit('update:value', unref(activeKey));
}


const visible = ref<boolean>(false);
const setVisible = (value): void => {
  visible.value = value;
};
const previewImage=ref('');
const handlePreview = async (file: UploadProps['fileList'][number]) => {
  let imageUrl = '';
  
  // 优先使用 response 中的数据
  if (file.response && file.response.data && file.response.data[0]) {
    imageUrl = '/api/pe-attachment/attachment/showImg/' + file.response.data[0].id;
  }
  // 其次使用 thumbUrl（缩略图）
  else if (file.thumbUrl) {
    imageUrl = file.thumbUrl;
  }
  // 最后使用 url
  else if (file.url) {
    imageUrl = file.url;
  }

  if (imageUrl) {
    previewImage.value = imageUrl;
    setVisible(true);
  }
};
const {
  dataUpload,
  uploadAction,
  headers,
} = useFileUploadHooks({emits, businessId,uploadAction:userUploadAction});

const {
  flushFileList,
  fileList,
  indicator,
  loadingFlag,
  uploadFileFlag,
} = useFileUploadHooks({imgUrl,emits, businessId},(records)=>{
  if(records&&Array.isArray(records)){
    records.forEach((itemDb)=>{
      if(!((itemDb.id+'').indexOf("/api")>0)){
        itemDb.url= '/api/pe-attachment/attachment/showImg/' + itemDb.id;
      }
    })
  }
});

const hasFile = computed(() => {
  if (fileList.value && fileList.value.length > 0) {
    return true;
  }
  return false;
})

const {removeFile}=useFileOperation(emits,flushFileList,imgUrl,fileList)
const hasError:any=ref(false);
const beforeUpload = async function (file) {
  emits("beforeUpload", {});
  if(!isNaN(parseInt(unref(maxSize)))){
    const isLt2M = file.size / 1024 / 1024 < parseInt(unref(maxSize)); // 小于 2MB
    if (!isLt2M) {
      nextTick(()=>{
        fileList.value=[];
        hasError.value=true
      })
      GoingUtils.showErrorMessage('图片大小必须小于'+unref(maxSize)+'Mb');
      return false;
    }
  }

  if (unref(multiple) === false) {
    if(unref(imgUrl)){
      fileList.value=[];
    }else{
      fileList.value=[];
      await delFileByBusId(unref(businessId)).then(() => {});
    }
  }
  //如果不是系统上传api则就无法删除操作 则直接设置为空
  if((unref(uploadAction)+'').indexOf("/attachment/upload")<0&&unref(multiple) === false){
    return;
  }
};

const handleChange = (info: UploadChangeParam) => {
  if(unref(hasError)){
    hasError.value=false;
    nextTick(()=>{
      fileList.value=[];
    })
    return;
  }
  if (info.file.status === 'uploading') {
    return;
  }
  uploadFileFlag.value=true;
  if (info.file.status === 'done') {
    ctx.emit('update:value', info.file.response.data[0].id);
    ctx.emit('update:imgUrl', `/api/pe-attachment/attachment/showImg/${info.file.response.data[0].id}`);
    ctx.emit('update:busId', unref(businessId));
    if(unref(imgUrl)){
      ctx.emit('update:value', `/api/pe-attachment/attachment/showImg/${info.file.response.data[0].id}`);
      return;
    }else{
      flushFileList();
    }
  }
  ctx.emit('done', {fileList:unref(fileList)});
  if (info.file.status === 'error') {
    message.error('upload error');
  }
}

watch(busId,(newVal)=>{
  if(newVal==null||newVal===''){
    fileList.value=[];
  }
})
const clearFileList=async function (){
  if(unref(imgUrl)){
    fileList.value=[];
  }else{
    await delFileByBusId(unref(businessId)).then(() => {
    });
  }
}
defineExpose({clearFileList})

</script>

<style type="text/css" lang="less">
.notMultiple.xm-img-upload{
  .ant-upload-list{
    display:flex;
  }
}
.ant-upload.ant-upload-select-picture-card{
  width: var(--imageWidth,100px);
  height: var(--imageWidth,100px);
}
</style>
